import React from 'react';
import { SectionHeading } from '../SectionHeading';
import { Carousel } from '../Carousel';
import { VolumeCard } from '../VolumeCard';
import { VOLUMES } from '../../data/collection';
export function CollectionSection() {
  return <section id="volumenes" aria-labelledby="volumenes-title" className="w-full bg-ivory" data-id="element-190" data-mp="17ezyzaeremei">
      <div className="mx-auto max-w-6xl px-5 py-16 sm:px-8 lg:py-24" data-id="element-191" data-mp="12gonywcqa5up">
        <SectionHeading id="volumenes-title" title="Elegí qué vas a coser primero." intro="31 modelos en seis volúmenes para que tu próxima costura no sea siempre la misma." data-id="element-192" data-mp="203ncukx6i9i1" />

        <div className="mt-10" data-id="element-193" data-mp="1qcam5wn49pdl">
          <Carousel items={VOLUMES} label="Los seis volúmenes" grid="md-2-lg-3" itemClassName="w-[82%] sm:w-[60%]" getKey={volume => String(volume.number)} renderItem={volume => <VolumeCard volume={volume} data-id="element-195" data-mp="2e2eom0okjj30" />} data-id="element-194" data-mp="1qbhpjohvgg96" />
        </div>
      </div>
    </section>;
}